<template>
  <PlayerLayout>
    <div class="d-flex flex-column flex-md-row mx-12 my-6" slot="main">
      <div class="d-flex flex-column flex-2 mr-md-6">
        <!-- Ensure this v-sheet has a defined size for the canvas -->
        <v-sheet color="black" rounded class="overflow-hidden">
          <GameEngine v-if="game && authUser" :codeString="game.codebase.code" :game="game" />
        </v-sheet>
      </div>
      <v-sheet v-if="game" class="d-flex flex-column flex-1" color="grey-lighten-4" rounded>
        <div class="d-flex flex-column">
          <div class="cal-sans-regular font-size-26">{{ game.title }}</div>
          <div class="cal-sans-regular font-size-16 my-2">{{ game.description }}</div>
          <div class="cal-sans-regular font-size-16">{{ game.instructions }}</div> <!-- Changed to 16 for consistency -->

          <v-btn disabled @click="playGame" color="secondary" class="black--text elevation-0 mt-4">
            <v-icon left>mdi-play</v-icon>
            Play
          </v-btn>
          <v-btn disabled @click="playGame" color="secondary" class="black--text elevation-0 mt-2">
            <v-icon left>mdi-stop</v-icon>
            Stop
          </v-btn>

          <v-btn disabled color="grey lighten-2" class="black--text elevation-0 mt-2">
            <v-icon left>mdi-code-braces</v-icon>
            Code
          </v-btn>

          <v-btn v-if="authUser" @click="riff" color="grey lighten-2" class="black--text elevation-0 mt-2">
            <v-icon left>mdi-guitar-pick-outline</v-icon>
            Riff
          </v-btn>

          <v-btn disabled color="grey lighten-2" class="black--text elevation-0 mt-2">
            <v-icon left>mdi-account-multiple-outline</v-icon>
            Multiplayer
          </v-btn>

          <v-btn v-if="authUser && game.creator && authUser.uid === game.creator.id" @click="edit" color="grey lighten-2" class="black--text elevation-0 mt-2">
            <v-icon left>mdi-pencil</v-icon>
            Edit Game
          </v-btn>
        </div>
      </v-sheet>
    </div>
  </PlayerLayout>
</template>

<script>
import { getDoc, doc } from 'firebase/firestore';
import { db } from '@/firebase/init';
import GameEngine from '@/components/GameEngine.vue';
import PlayerLayout from '@/layouts/Player.vue';

export default {

  name: 'GamePlayer',

  components: {
    GameEngine,
    PlayerLayout,
  },

  data() {
    return {
      game_id: null,
      loading: false,
      game: null,
    };
  },

  methods: {

    loadGame() {
      this.loading = true;
      this.game_id = this.$route.params.id;
      if (this.game_id) {
        const gameRef = doc(db, 'games', this.game_id);
        getDoc(gameRef)
          .then((doc) => {
            if (doc.exists()) {
              let gameData = doc.data();
              gameData.id = doc.id;
              this.game = gameData;
            } else {
              console.error('No such document!');
              this.game = null; // Handle case where game doesn't exist
            }
            this.loading = false;
          })
          .catch((error) => {
            console.error('Error getting document:', error);
            this.loading = false;
            this.game = null;
          });
      } else {
        this.loading = false;
      }
    },

    playGame() {
      console.log('playGame')
    },

    async riff() {
      await this.$creator.riff('game', this.game.id, this.profile);
    },
    
    edit() {
      this.$creator.edit('game', this.game.id);
    }

  },

  created() {
    this.loadGame();
  },

  watch: {
    '$route.params.id': {
      immediate: true, // Load game immediately if id is present on initial load
      handler(newId, oldId) {
        if (newId !== oldId) {
          this.loadGame();
        }
      },
    },
  },
};
</script>